<template>
  <div class="page-content coupons-manager">
    <div class="flex flex-wrap items-center justify-between gap-4 mb-4">
      <div>
        <div class="title">Coupons</div>
        <p class="text-sm text-gray-500">
          Discounts on the whole order, free shipping, or on specific products,
          categories and subcategories.
        </p>
      </div>
      <button
        @click="showCreateCouponForm = true"
        class="btn btn-dark-button h-10 flex items-center justify-center px-4"
      >
        + New coupon
      </button>
    </div>

    <div class="flex flex-wrap items-center gap-2 mb-4">
      <input
        v-model="search"
        type="text"
        class="regular bordered h-10 w-64"
        placeholder="Search by code"
      />
      <button
        v-for="option in stateFilters"
        :key="option.code"
        type="button"
        class="px-3 py-1 rounded-full text-sm border"
        :class="
          stateFilter === option.code
            ? 'bg-gray-800 text-white border-gray-800'
            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
        "
        @click="stateFilter = option.code"
      >
        {{ option.name }}
        <span class="ml-1 opacity-75">{{ countByState(option.code) }}</span>
      </button>
    </div>

    <CreateCoupon
      v-if="showCreateCouponForm"
      @close="showCreateCouponForm = false"
      @created="onCreated"
    />
    <EditCoupon
      v-if="editingCoupon"
      :coupon="editingCoupon"
      :initial-tab="editingTab"
      @close="closeEdit"
      @updated="
        () => {
          closeEdit();
          getCoupons();
        }
      "
      @rulesChanged="getCoupons"
    />

    <div v-if="loading" class="loading">
      <BaseSmallSpinner />
    </div>
    <div
      v-else-if="filteredCoupons.length === 0"
      class="border border-dashed rounded-md p-8 text-center text-gray-500"
    >
      {{ coupons.length === 0 ? "No coupons yet" : "No coupons match" }}
    </div>
    <div v-else class="grid gap-4 coupons-grid">
      <CouponItem
        v-for="coupon in filteredCoupons"
        :key="coupon.id"
        :coupon="coupon"
        @edit="openEdit"
        @deleted="getCoupons"
      />
    </div>
  </div>
</template>

<script>
import { getCoupons as getCouponsApi } from "@/api/store/CouponsService.js";
import CouponItem from "@/components/coupons/CouponItem.vue";
import CreateCoupon from "@/components/coupons/CreateCoupon.vue";
import EditCoupon from "@/components/coupons/EditCoupon.vue";
import {
  couponState,
  COUPON_STATES
} from "@/components/coupons/couponLabels.js";

export default {
  name: "CouponsManager",
  components: {
    CouponItem,
    CreateCoupon,
    EditCoupon
  },
  data() {
    return {
      coupons: [],
      loading: false,
      search: "",
      stateFilter: "all",
      editingCoupon: null,
      editingTab: "general",
      showCreateCouponForm: false
    };
  },
  computed: {
    stateFilters() {
      return [{ code: "all", name: "All" }].concat(
        Object.keys(COUPON_STATES).map(code => ({
          code,
          name: COUPON_STATES[code].name
        }))
      );
    },
    filteredCoupons() {
      const search = this.search.trim().toLowerCase();
      return this.coupons.filter(
        coupon =>
          (this.stateFilter === "all" ||
            couponState(coupon) === this.stateFilter) &&
          (!search || coupon.code.toLowerCase().includes(search))
      );
    }
  },
  mounted() {
    this.getCoupons();
  },
  methods: {
    getCoupons() {
      this.loading = this.coupons.length === 0;
      getCouponsApi()
        .then(res => {
          this.coupons = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    countByState(state) {
      if (state === "all") return this.coupons.length;
      return this.coupons.filter(coupon => couponState(coupon) === state)
        .length;
    },
    openEdit(coupon, tab = "general") {
      this.editingTab = tab;
      this.editingCoupon = coupon;
    },
    closeEdit() {
      this.editingCoupon = null;
      this.editingTab = "general";
    },
    // Un cupón "by product" no descuenta nada hasta tener reglas: se abre
    // directo en la pestaña de reglas.
    onCreated(coupon) {
      this.showCreateCouponForm = false;
      this.getCoupons();
      if (coupon && coupon.id && coupon.discountType === "product") {
        this.openEdit(coupon, "categories");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.coupons-grid {
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
}
</style>
